import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const card: SxStyle = {
  borderStyle: 'dashed',
  borderRadius: (p) => p.spacing(0.5),
  backgroundColor: (p) => p.palette.grey[50],
};

export const cardContent: SxStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItem: 'center',
};
